module.exports = __webpack_public_path__ + "img/details-product-mob.b1071f7.webp";